import { baseApi } from "@/app/store/api/baseApi";

export interface PaymentStatus {
  configured: boolean;
  gateway: string;
  status: "disconnected" | "connected" | "error";
  mode: string;
  account_id: string;
  account_display_name: string;
  charges_enabled: boolean;
  payouts_enabled: boolean;
  connected_at: string | null;
  last_verified_at: string | null;
  error_message: string;
  pending_requirements: string[];
}

const paymentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    paymentStatus: builder.query<PaymentStatus, void>({
      query: () => ({ url: "/payments/status/status/" }),
      providesTags: [{ type: "Payments", id: "STATUS" }],
    }),
    stripeConnect: builder.mutation<
      { authorization_url: string; flow: "oauth" | "onboarding" },
      { return_url?: string } | void
    >({
      query: (body) => ({
        url: "/payments/stripe/connect/",
        method: "POST",
        body: body ?? {},
      }),
      invalidatesTags: [{ type: "Payments", id: "STATUS" }],
    }),
    stripeDisconnect: builder.mutation<PaymentStatus, void>({
      query: () => ({
        url: "/payments/stripe/disconnect/",
        method: "POST",
      }),
      invalidatesTags: [{ type: "Payments", id: "STATUS" }],
    }),
  }),
});

export const {
  usePaymentStatusQuery,
  useStripeConnectMutation,
  useStripeDisconnectMutation,
} = paymentsApi;
